import React from "react"
import { Input, Label } from "reactstrap"

function CheckboxType({ answers = [] }) {
  return (
    <>
      {answers.map((i, k) => (
        <span key={k} className="mx-1">
          <Input type="checkbox" readOnly checked={i.answer} disabled />
          <Label className="ms-1">{i.label}</Label>
        </span>
      ))}
    </>
  )
}

export default CheckboxType
